import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/produceStyles'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'produceStyles'

export const metadata = {
  icon: 'clone',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const ProduceStylesListPage = createListPage({ metadata, api, actionCreators, Content })
const ProduceStylesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { ProduceStylesListPage, ProduceStylesDetailPage }
